import React from "react";
import Content from "./manage/Overview";
import AllCountriesDashboard from "./CountriesDashboard";
import CountryDashboardComponent from "./manage/CountryDashboardComponent";
import Add from "./manage/Add";
import Edit from "./manage/Edit";
import { ContinentRegionProvider } from "../../context/ContinentRegionContext";

import { TradeOrganizationProvider } from "../../context/TradeOrganizationContext";
import { PlugImageProvider } from "../../context/PlugImageContext";
import { RegionalBlocksProvider } from "../../context/RegionalBlocksContext";

export const Countries = () => {
  return (
    
      <Content />
    
  );
};

export const CountriesDashboard = () => {
  return (
    
      <AllCountriesDashboard />
    
  );
};

export const CountryDashboard = () => {
  return (
    
      <CountryDashboardComponent />
    
  );
};

export const AddCountry = () => {
  return (
    <TradeOrganizationProvider>
      <PlugImageProvider>
        <RegionalBlocksProvider>
          <ContinentRegionProvider>
            
              <Add />
            
          </ContinentRegionProvider>
        </RegionalBlocksProvider>
      </PlugImageProvider>
    </TradeOrganizationProvider>
  );
};

export const EditCountry = () => {
  return (
    <TradeOrganizationProvider>
      <PlugImageProvider>
        <RegionalBlocksProvider>
          <ContinentRegionProvider>
            
              <Edit />
            
          </ContinentRegionProvider>
        </RegionalBlocksProvider>
      </PlugImageProvider>
    </TradeOrganizationProvider>
  );
};
